import React from 'react';
import Container from 'shared/container';
import Headline from 'shared/headline';
import Brand from 'shared/person-card';
import s from './partners.module.scss';

function PartnersSection({ cards = [], ...props }) {
  return (
    <Container className={s.root}>
      <Headline title h1 html="partners" className={s.headline} el="h3" />
      <div className={s.cardWrapper}>
        {cards && cards.length > 0 &&
          cards.map(brand => (
            <div className={s.brandWrapper} key={brand?.name}>
              <Brand {...brand} small />
            </div>
          ))}
      </div>
    </Container>
  );
}
export default PartnersSection;
